import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bidi-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
